const SECRET_PATH_PREFIXES = ['/auth/password-reset/', '/auth/verify-email/'];

export function hasSecretInPath(pathname = window.location.pathname) {
  return SECRET_PATH_PREFIXES.some((p) => pathname.startsWith(p));
}

// Remove a trailing single-use key from the address bar / history entry
// without triggering a router navigation (the component keeps the key in
// memory). Vue Router's `current` history state is kept in sync.
export function stripKeyFromUrl(key) {
  if (typeof window === 'undefined' || !key) return;
  const segments = window.location.pathname.split('/');
  if (decodeURIComponent(segments[segments.length - 1]) !== key) return;
  const clean = segments.slice(0, -1).join('/') + window.location.search + window.location.hash;
  window.history.replaceState({ ...window.history.state, current: clean }, '', clean);
}
